export default {
  headers: {
    edit_time: 'Uhrzeit bearbeiten',
    create_time: 'Uhrzeit erstellen',
  },
  labels: {
    select_all: 'Alle auswählen',
  },
  buttons: {
    add_opening_time: 'Öffnungszeit hinzufügen',
    add: 'Hinzufügen',
    cancel: 'Abbrechen',
  },
};
